let authValidatedThisPageLoad = false

export async function checkStoredAuthToken(apiBaseUrl: string, token: string): Promise<boolean> {
  const resp = await fetch(new URL("auth/check", apiBaseUrl), {
    headers: {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    },
  })

  return resp.ok
}

/** Validates the stored token once per full browser load (not on client-side navigations). */
export async function validateAuthOnPageLoad(apiBaseUrl: string, token: string): Promise<boolean> {
  if (authValidatedThisPageLoad) {
    return true
  }

  const ok = await checkStoredAuthToken(apiBaseUrl, token)
  if (ok) {
    authValidatedThisPageLoad = true
  }

  return ok
}
